<template>
  <section class="main-diff-section width">
    <article>
      <title class="flex-col-center sm-title">맞춤형 배송 관리</title>
      <div class="lg-title">
        기업형 고객을 위한 <br />
        Custom 서비스
      </div>
      <div class="text-bl desc">
        API 자동접수, 기업 전용 관리페이지, 당일배송, 새벽배송 등 맞춤형 배송을
        제공합니다.
      </div>
    </article>
    <div class="diff-feat">
      <img class="dev-img" src="@/assets/img/main/img_dev.png" />
      <article class="flex-col">
        <div class="card-title text-bl">전담 개발 조직 운영</div>
        <div class="font-14 text-light-gr">(Platform innovation center)</div>
        <div class="desc text-gr font-14">
          디버의 전문 개발 조직이 고객 전용 페이지의 <br />커스터마이징이
          가능하도록 합니다.<br />더욱 편리한 맞춤형 서비스를 만나보세요.
        </div>
      </article>
    </div>
    <div class="diff-feat-2">
      <img
        class="total-img for-mobile"
        src="@/assets/img/main/mobile/total_mobile.png"
      />
      <img
        class="total-img for-desktop"
        src="@/assets/img/main/desktop/total_desktop.png"
      />
      <article class="flex-col">
        <div class="card-title text-bl">사용자 별 이용 통계 제공</div>
        <div class="desc text-gr font-14">
          보안이 강화된 SSO 전용 관리 페이지를 제공하여<br />
          사용자/부서별 이용 통계 확인이 가능합니다.
        </div>
      </article>
    </div>
    <div class="diff-feat">
      <img class="api-img" src="@/assets/img/main/img_api.png" />
      <article class="flex-col custom-api">
        <div class="card-title text-bl">기업별 커스텀 대응</div>
        <div class="desc text-gr font-14">
          디버의 전담 개발 조직과 정규직 운영팀이 기업별 API 연동 주문접수 및,
          정보 보호, 계약 단가별 운영을 책임집니다.
        </div>
        <div class="more-btn">
          API 문서 보기<img
            class="ic_arrow"
            src="@/assets/img/main/arrow_right_up.png"
          />
        </div>
      </article>
    </div>

    <div class="dpost-area">
      <img
        class="dpost-img for-mobile"
        src="@/assets/img/main/mobile/dpost_mobile.png"
      />
      <img
        class="dpost-img1 for-desktop"
        src="@/assets/img/main/desktop/dpost_desktop1.png"
      />
      <img
        class="dpost-img2 for-desktop"
        src="@/assets/img/main/desktop/dpost_desktop2.png"
      />
      <article class="flex-col dpost">
        <div class="card-title text-bl">프라이빗 메일룸 제공</div>
        <div class="desc text-gr font-14">
          우리 회사만의 메일룸! 필요하지 않으셨나요? <br />편리하고 깔끔한
          스마트 메일룸 ‘디포스트’를 만나보세요.
        </div>
        <div class="more-btn" @click="moveDpost()">
          디포스트 알아보기<img
            class="ic_arrow"
            src="@/assets/img/main/arrow_right_up.png"
          />
        </div>
      </article>
    </div>
  </section>
</template>
<script>
export default {
  methods: {
    moveDpost() {
      window.open("http://www.dpost.co.kr");
    },
  },
};
</script>
<style src="./mainCommon.css" scoped></style>
<style scoped>
.main-diff-section {
  display: flex;
  flex-direction: column;
}
article {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 1rem 0 2rem 0;
}

img {
  border-radius: 0.5rem;
  width: 100%;
}

.more-btn {
  border: 1px solid #2ea3ff;
  border-radius: 38px;
  width: fit-content;
  padding: 0.5rem 1rem;
  margin: 0.5rem 0;
  color: #2ea3ff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.diff-feat {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: center;
}

.diff-feat-2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ic_arrow {
  width: 18px;
}

.dpost-area {
  position: relative;
}

/* .dpost-img1 {
  position: absolute;
  left: 0;
}

.dpost-img2 {
  right: 0;
  top: 70%;
} */

@media all and (min-width: 1281px) {
  article {
    height: 210px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .dev-img {
    width: 498px;
    height: 328px;
  }

  .api-img {
    width: 557px;
    height: 303px;
  }

  .total-img {
    height: 432px;
    width: 432px;
  }

  article.flex-col {
    height: 150px;
    justify-content: space-evenly;
  }

  .diff-feat,
  .diff-feat-2 {
    margin: 60px auto;
    width: 900px;
  }

  .custom-api {
    width: 290px;
    min-height: 200px;
  }

  .dpost-img1 {
    position: absolute;
    left: 0;
    width: 70%;
  }

  .dpost-img2 {
    position: absolute;
    width: 40%;
    right: 0;
    top: 27%;
  }

  article.flex-col.dpost {
    position: absolute;
    bottom: 20%;
    left: 3%;
    justify-content: space-evenly;
    width: 500px;
    height: 200px;
  }

  .dpost-area {
    height: 800px;
    width: 900px;
    margin: 50px auto;
  }

  .card-title {
    font-weight: 700;
    font-size: 28px;
    line-height: 28px;
  }
}

@media all and (min-width: 769px) and (max-width: 1280px) {
  article {
    height: 170px;
  }
  article.flex-col {
    height: 200px;
    justify-content: space-evenly;
    width: 327px;
  }

  .dev-img {
    width: 326px;
    height: 215px;
  }

  .total-img {
    height: 327px;
    width: 326px;
  }

  .api-img {
    width: 326px;
    height: 190px;
  }

  .dpost-img1 {
    position: absolute;
    left: 0;
    height: 275px;
    width: 557px;
  }

  .dpost-img2 {
    position: absolute;
    width: 266px;
    height: 325px;
    right: 0;
    top: 30%;
  }

  article.flex-col.dpost {
    position: absolute;
    bottom: 0;

    justify-content: space-evenly;
    width: 350px;
  }

  .diff-feat {
    margin: 50px 0;
  }

  .dpost-area {
    height: 500px;
  }

  .card-title {
    font-size: 22px;
    line-height: 28px;
    font-weight: 700;
    color: #4e5459;
  }
}

@media all and (max-width: 768px) {
  article.flex-col {
    height: 150px;
    justify-content: center;
  }
  .main-diff-section {
    min-height: 2000px;
  }
  .dev-img,
  .dpost-img {
    margin: 0.5rem 0;
  }

  .api-img {
    width: 320px;
    height: 210px;
  }

  .ic_arrow {
    width: 18px;
    margin-left: 10px;
  }

  .diff-feat,
  .diff-feat-2 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .card-title {
    font-weight: 500;
    font-size: 20px;
    line-height: 25px;
    letter-spacing: -1.5px;
  }
}
</style>
